import React from 'react';
import { DndContext, DragOverlay, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { ItemRow } from './places-overview.jsx';
import { usePlaceDragAndDrop } from './use-place-dnd.js';

export default function PlacesDnD(props) {
    const { location, placeType, children, movePlace, selectedPlaceId } = props;

    // DRAG AND DROP
    const { onDragStart, onDragEnd, onDragCancel, draggedPlace, ids, sensors } = usePlaceDragAndDrop({
        selectedPlaceId,
        location,
        placeType,
        movePlace
    });

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragCancel={onDragCancel}
        >
            <div>
                <SortableContext items={ids} strategy={verticalListSortingStrategy}>
                    {...children}
                </SortableContext>

                <DragOverlay
                    style={{
                        cursor: 'grabbing',
                        border: 'none'
                    }}
                >
                    {draggedPlace && (
                        <ItemRow
                            style={{
                                border: '1px solid #00000033',
                                borderRadius: '0.5rem',
                                padding: '0.5rem',
                                cursor: 'grabbing'
                            }}
                            overlay={true}
                            {...draggedPlace}
                        />
                    )}
                </DragOverlay>
            </div>
        </DndContext>
    );
}
